module.exports = __webpack_public_path__ + "media/images/show-d28533439f49bf068b79c73272d8cb5e.svg";